export default "__VITE_ASSET__BwZ73buH__"